import { createApp, configureCompat } from 'vue'

configureCompat({
  MODE: 2
})

import App from './App'
import router from './router'
import store from './store'
import './language/ml'
import { abilitiesPlugin } from '@casl/vue'
import ability from './services/ability'
import VueGtag from 'vue-gtag'
import vSelect from 'vue-select'
import VTooltip from 'v-tooltip'
import excel from 'vue-excel-export'
import Notifications from 'vue-notification'
import VueTheMask from 'vue-the-mask'
import 'v-form-builder/dist/v-form-builder.css'
import VueExcelEditor from 'vue-excel-editor'
import VCharts from 'v-charts'

const currencyData = require('./services/currency')

const app = createApp(App)
const globalRootRefs = {}

app.mixin({
  beforeCreate() {
    if (this.$ && (!this.$.refs || Object.isFrozen(this.$.refs) || !Object.isExtensible(this.$.refs))) {
      this.$.refs = {}
    }
    if (this.$root) {
      if (!this.$root.$refs || Object.isFrozen(this.$root.$refs) || !Object.isExtensible(this.$root.$refs)) {
        try {
          Object.defineProperty(this.$root, '$refs', {
            value: globalRootRefs,
            writable: true,
            configurable: true
          })
        } catch (e) {
          if (this.$root.$) {
            this.$root.$.refs = globalRootRefs
          }
        }
      }
    }
  },
  methods: {
    currencySymbol: function (id){
      if(id){
        return currencyData.filter(c => { return c.id == id })[0].symbol
      }else{
        return '#undefined_currency_symbol#'
      }
    },
    currencyData: function (){
      return currencyData
    },
    currencyLabel: function(id){
      if(id){
        let label = currencyData.filter(c => { return c.id == id })[0].label
        if(label){
          return label
        }else{
          return '#unknown_currency#'
        }
      }else{
        return '#undefined_currency_label#'
      }
    }
  }
})

app.use(abilitiesPlugin, ability)
app.component('v-select', vSelect)
app.use(VTooltip)
app.use(excel)
app.use(Notifications)
app.use(VueTheMask)
app.use(VueExcelEditor)
app.use(VCharts)
app.use(store)
app.use(router)

router.isReady().then(() => app.mount('#app'))
